export const CREATE_VACANCY_PATH = "/vacancies/create";
